<template>
  <div
    class="embed section"
    :style="sectionStyle"
  >
    <div class="container flex column items-center">
      <div
        v-if="title"
        class="text-center q-mb-md"
        :style="titleStyle"
      >
        {{ title }}
      </div>
      <div
        v-if="description"
        :style="descriptionStyle"
        class="description text-center q-mb-lg"
      >
        {{ description }}
      </div>
      <div
        class="embed-block"
        v-html="html"
      />
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'EmbedSection',
  mixins: [backgroundMixin, titleMixin, descriptionMixin],
  props: {
    html: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  max-width: 600px;
}

.embed-block {
  position: relative;
  padding-bottom: 56.25%;
  width: 100%;

  ::v-deep iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
